module.exports = __webpack_public_path__ + "img/latest-result-banner-bg-3.75866245.webp";